import { Col, Row } from 'antd';
import DefaultLayout from '../components/DefaultLayout';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

function Services() {
    return (
        <DefaultLayout>

            <Row className='p-5' justify='center' gutter={24}>
                <Col lg={20} sm={24} xs={24}>
                    <div>
                        <h1>Our Services</h1>

                        <div>
                            <p>We offer chauffeured car hire Nairobi services with a huge variety of cars to select from in Nairobi County. Search, book and pay online in minutes which is a true indication of how our services are fast. Did you know that Nairobi County is one of the smallest and yet the most populous of the counties? It is coterminous with the city of Nairobi, which is also the capital and largest city of Kenya.</p>
                            <p>When you decide hire car Nairobi, you have to make sure you get a company that’s trustworthy, reliable and has a good reputation. The good customer reviews about Smart Car services Kenya will offer you a chance to clear your doubts about our past client’s experiences hence give you a solid assurance that we are indeed the best car hiring company within the County of Nairobi.</p>

                            <p style={{display: 'flex', justifyContent: 'flex-start'}}>Here are the list of services that we offer: </p>
                            <ul style={{display: 'flex-block'}}>
                                <li style={{display: 'flex', justifyContent: 'flex-start'}}><b> Airport Travels</b></li>
                                <li style={{display: 'flex', justifyContent: 'flex-start'}}><b>Wedding Transport Services</b></li>
                                <li style={{display: 'flex', justifyContent: 'flex-start'}}><b>Private Travel services</b></li>
                                <li style={{display: 'flex', justifyContent: 'flex-start'}}><b>City and Safari Tours</b></li>
                                <li style={{display: 'flex', justifyContent: 'flex-start'}}><b>Goods and Cargo Transfer</b></li>
                            </ul>

                        </div>
                    </div>
                </Col>
                <Col lg={10} sm={24} xs={24} className="text-right p-3 mt-5">
                    <div>
                        <button className="btn1" style={{backgroundColor: 'orangered', color: 'white'}}>
                            <Link className='book' to='/'>
                                <FontAwesomeIcon icon={faAngleLeft} size="3x" className='m-0' style={{color: 'orangered'}}/>Back
                            </Link>
                        </button>
                    </div>
                </Col> 
            </Row>
        </DefaultLayout> 
    );
}

export default Services;